const navbarData = [
    {
        name: "Home",
        path: '',
        icon: ""
    },

    {
        name: "About",
        path: '',
        icon: ""
    }
];

export default navbarData;